<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large" style="min-height: 80%" v-if="this.paid_status === 0">
      <header class="modal-card-head">
        <p class="modal-card-title">Edit Payment Orders</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-grouped">
          <p class="control is-expanded">
            <label class="label">Payment Status</label>
            <select name="payment" id="payment" v-model="payment.payment" class="select is-fullwidth">
              <option value="">None</option>
              <option value="2">Billed</option>
              <option value="3">Pending</option>
              <option value="4">Legal Pending</option>
            </select>
          </p>
          <p class="control is-expanded">
            <label class="label">Deadline</label>
            <datepicker ref="deadline" placeholder="Date"></datepicker>
          </p>
        </div>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="payment.pre_payment">
            Pre Payment
          </label>
        </p>
        <div class="control is-grouped">
          <p class="control is-expanded">
            <label class="label">Pre Payment Method</label>
            <select v-model="payment.pre_payment_method" class="select is-fullwidth">
              <option value="0">None</option>
              <option value="1">Card</option>
              <option value="2">Boleto</option>
              <option value="3">Commission</option>
              <option value="4">Transfer</option>
              <option value="5">Pre-payment</option>
              <option value="6">Credit</option>
              <option value="7">No rule</option>
            </select>
          </p>
          <p class="control is-expanded" v-if="parseInt(payment.pre_payment_method) === 2 && payment.pre_payment_method !== '' && !this.context._data.selectedItens[1]">
            <label class="label">Seu numero/Num. Documento</label>
            <input class="input" type="text" name="seu_numero" id="seu_numero" placeholder="Boleto" v-model.trim="payment.seu_numero">
          </p>
          <p class="control is-expanded" v-if="payment.seu_numero !== ''">
            <label class="label">CNPJ (Boleto)</label>
            <input class="input" type="text" name="cnpj_boleto" id="cnpj_boleto" placeholder="CNPJ do boleto" v-model.trim="payment.cnpj_boleto">
          </p>
          <p class="control is-expanded" v-if="parseInt(payment.pre_payment_method) === 1">
            <label class="label">Card Tag (Month)</label>
            <select v-model="payment.card_tag_month" class="select is-fullwidth">
              <option value="0">Choose Month</option>
              <option value="1">Janeiro</option>
              <option value="2">Fevereiro</option>
              <option value="3">Março</option>
              <option value="4">Abril</option>
              <option value="5">Maio</option>
              <option value="6">Junho</option>
              <option value="7">Julho</option>
              <option value="8">Agosto</option>
              <option value="9">Setembro</option>
              <option value="10">Outubro</option>
              <option value="11">Novembro</option>
              <option value="12">Dezembro</option>
            </select>
          </p>
          <p class="control is-expanded" v-if="parseInt(payment.pre_payment_method) === 1">
            <label class="label">Card Tag (Year)</label>
            <select v-model="payment.card_tag_year" class="select is-fullwidth">
              <option value="0">Choose Year</option>
              <option :value="this.year - 2">{{ this.year - 2 }}</option>
              <option :value="this.year - 1">{{ this.year - 1 }}</option>
              <option :value="this.year">{{ this.year }}</option>
              <option :value="this.year + 1">{{ this.year + 1 }}</option>
            </select>
          </p>
        </div>
        <div class="control is-grouped" v-if="parseInt(payment.pre_payment_method) === 1">
          <p class="control is-expanded">
            <label class="label">Change Card</label>
            <v-select
              :options="parseCards(cards)"
              placeholder="Change Card"
              label="name"
              v-model="payment.change_card"
            >
            </v-select>
          </p>
        </div>
        <div class="control is-grouped">
          <v-select
            :options="parsePaymentMethodSelect(payment_methods)"
            placeholder="Search Payment Method"
            label="name"
            max-height="100px"
            v-model="payment.payment_method"
            v-if="payment_methods"
            style="width: 100%"
          >
          </v-select>
        </div>
        <div class="control is-grouped" v-if="show_nf === 1">
          <p class="control is-expanded">
            <label class="label">Nota Fiscal</label>
            <input v-for="(nf_number, index) in nf_numbers" :key="index" class="input" type="number" name="nf_number" id="nf_number" placeholder="Number" v-model.trim="nf_number.value">
          </p>
          <p class="control is-expanded">
            <label class="label">CNPJ (Nota Fiscal)</label>
            <input v-for="(cnpj_nf, index) in cnpjs_nf" :key="index" :class="{'input': true, 'is-danger': errors.has('cnpj_nf'), 'is-disabled': inProgress}" type="text" name="cnpj_nf" id="cnpj_nf" ref="cnpj_nf" placeholder="CNPJ" v-model.trim="cnpj_nf.value" v-validate="'required'">
            <span v-show="errors.has('cnpj_nf')" class="help is-danger">O CNPJ da nota fiscal é obrigatório</span>
          </p>
        </div>
        <button class="button is-warning" v-if="!this.context._data.selectedItens[1]" @click="addNotaFiscal()" style="margin-bottom: 5px;">Add Nota Fiscal</button>
        <p class="control is-expanded" v-if="!this.context._data.selectedItens[1]">
          <label class="label">Observações</label>
          <textarea class="input" type="textarea" name="comments" id="comments" placeholder="Inserir observações relevantes" v-model.trim="payment.comments" style="min-height: 100px;"></textarea>
        </p>
        <p class="control is-expanded" v-show="payment.payment_id.length === 1">
          <label class="label">Boleto <i class="fa fa-check-square-o" v-if="this.context._data.selectedItens[0] && this.context._data.selectedItens[0].invoice === 1"></i></label>
          <input type="file" id="invoice" ref="invoice" v-on:change="handleFileUploadInvoice()"/>
        </p>
        <p class="control is-expanded" v-show="payment.payment_id.length === 1">
          <label class="label">Comprovante <i class="fa fa-check-square" v-if="this.context._data.selectedItens[0] && this.context._data.selectedItens[0].receipt === 1"></i></label>
          <input type="file" id="receipt" ref="receipt" v-on:change="handleFileUploadReceipt()"/>
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || inProgress || error !== '', 'is-loading': inProgress}" @click="save(true)">Save and Pay</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || inProgress || error !== '', 'is-loading': inProgress}" @click="save()">Save</a>
          </p>
        </div>
      </footer>
    </div>
    <div class="modal-card is-large" v-if="this.paid_status === 1">
      <header class="modal-card-head">
        <p class="modal-card-title">Edit Paid Payment Orders</p>
      </header>
      <section class="modal-card-body">
        <div class="control is-grouped">
          <p class="control is-expanded" v-if="parseInt(this.pre_payment_method) === 1">
            <label class="label">Card Tag (Month)</label>
            <select v-model="payment.card_tag_month" class="select is-fullwidth">
              <option value="0">Choose Month</option>
              <option value="1">Janeiro</option>
              <option value="2">Fevereiro</option>
              <option value="3">Março</option>
              <option value="4">Abril</option>
              <option value="5">Maio</option>
              <option value="6">Junho</option>
              <option value="7">Julho</option>
              <option value="8">Agosto</option>
              <option value="9">Setembro</option>
              <option value="10">Outubro</option>
              <option value="11">Novembro</option>
              <option value="12">Dezembro</option>
            </select>
          </p>
          <p class="control is-expanded" v-if="parseInt(this.pre_payment_method) === 1">
            <label class="label">Card Tag (Year)</label>
            <select v-model="payment.card_tag_year" class="select is-fullwidth">
              <option value="0">Choose Year</option>
              <option :value="this.year - 2">{{ this.year - 2 }}</option>
              <option :value="this.year - 1">{{ this.year - 1 }}</option>
              <option :value="this.year">{{ this.year }}</option>
              <option :value="this.year + 1">{{ this.year + 1 }}</option>
            </select>
          </p>
        </div>
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control is-expanded" v-if="parseInt(this.pre_payment_method) !== 1">
          <label class="label">Comprovante <i class="fa fa-check-square" v-if="this.context._data.selectedItens[0] && this.context._data.selectedItens[0].receipt === 1"></i></label>
          <button v-if="this.context._data.selectedItens[0] && this.context._data.selectedItens[0].receipt === 1 && upload_new_receipt" @click="showReceiptUpload()">Adicionar Novo Comprovante</button>
          <button v-if="this.context._data.selectedItens[0] && !this.context._data.selectedItens[0].receipt && upload_new_receipt" @click="showReceiptUpload()">Adicionar Comprovante</button>
          <input v-if="!upload_new_receipt" type="file" id="receipt" ref="receipt" v-on:change="handleFileUploadReceipt()"/>
          <button v-if="this.context._data.selectedItens[0] && this.context._data.selectedItens[0].receipt === 1" style="float:right" @click="sendReceiptToHotel()">Enviar Comprovante</button>
        </p>
        <span v-if="loadedPayment && loadedPayment.chain && !loadedPayment.chain.receipt_email && !updateEmail && parseInt(this.pre_payment_method) !== 1"><a @click="updateEmail = 1">E-mail de comprovante do Hotelier não cadastrado - clique aqui para cadastrar</a></span>
        <span v-if="loadedPayment && loadedPayment.hotel && !loadedPayment.hotel.receipt_email && !updateEmail && parseInt(this.pre_payment_method) !== 1"><a @click="updateEmail = 1">E-mail de comprovante do hotel não cadastrado - clique aqui para cadastrar</a></span>
        <p v-if="updateEmail" class="control">
          <label class="label">Email Comprovante</label>
          <input style="width: 200px" :class="{'input': true, 'is-danger': errors.has('email'), 'is-disabled': inProgress}" type="email" name="receipt_email" id="receipt_email" placeholder="Email" v-model="receipt_email" v-validate="'required'">
          <button class="button" style="background: #91181c; color: white" @click="updateProviderReceiptEmail()">Atualizar Email</button> <span v-show="errors.has('receipt_email')" class="help is-danger">{{ errors.first('receipt_email') }}</span>
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || inProgress || error !== '', 'is-loading': inProgress}" @click="save(true)">Save and Pay</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || inProgress || error !== '', 'is-loading': inProgress}" @click="save()">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import babelPolyfill from 'babel-polyfill'
  import Datepicker from 'vue-bulma-datepicker'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import message from '../../../../utils/message'
  export default {
    props: {
      context: {
        type: Object
      },
      payment_id: {
        type: Array,
        required: true
      },
      paid_payment: {
        type: Number,
        required: true
      },
      paid_status: {
        type: Number,
        required: true
      },
      pre_payment_method: {
        type: Number,
        required: true
      },
      currency: {
        type: Array,
        required: false
      },
      amount: {
        type: Number,
        required: false
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        payment: {
          payment_id: [],
          payment: '',
          deadline: '',
          payment_method: '',
          pre_payment_method: '',
          // invoice_number: '',
          seu_numero: '',
          cnpj_boleto: '',
          card_tag_month: 0,
          card_tag_year: 0,
          change_card: null,
          nf_number: '',
          cnpj_nf: '',
          comments: '',
          pre_payment: 0
        },
        inProgress: false,
        error: '',
        file: null,
        file2: null,
        payment_methods: null,
        upload_new_receipt: 1,
        loadedPayment: null,
        updateEmail: null,
        receipt_email: '',
        year: new Date().getFullYear(),
        cards: [],
        remove_user_id: '',
        nf_numbers: [],
        cnpjs_nf: [],
        show_nf: 0
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
        this.payment.payment_id = this.payment_id
        this.loadMethods()
        this.loadCards()
        this.loadData()
      })
    },
    methods: {
      addNotaFiscal () {
        this.show_nf = 1
        this.nf_numbers.push({})
        this.cnpjs_nf.push({})
      },
      updateProviderReceiptEmail () {
        if (window.confirm('Are you sure you want to update the provider receipt e-mail?')) {
          var url = null
          this.$validator.validateAll().then(() => {
            if (this.errors.items.length === 0) {
              this.inProgress = true
              this.error = ''
              if (this.loadedPayment.chain) {
                url = this.context.$store.state.config.apiURL + '/chains/' + this.loadedPayment.chain.id
              } else if (this.loadedPayment.hotel) {
                url = this.context.$store.state.config.apiURL + '/hotels/' + this.loadedPayment.hotel.id
              }
              this.context.$http.post(url, {receipt_email_from_edit_payment: this.receipt_email}).then((response) => {
                this.inProgress = false
                this.message('success', 'Success', 'The new receipt e-mail was successfully updated')
                this.close(true)
                setTimeout(() => {
                  window.location.reload()
                }, 2000)
              }, (response) => {
                this.inProgress = false
                this.message('danger', 'Error', response.body)
                this.close(true)
              })
            }
          })
        }
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/V2/payment/' + this.context._data.selectedItens[0].id).then((response) => {
          this.loadedPayment = response.body
          if (this.payment_id.length === 1) {
            this.payment.comments = this.loadedPayment.comments
            if (!this.loadedPayment.cnpj_boleto) {
              if (this.loadedPayment.chain && this.loadedPayment.chain.cnpj) {
                this.payment.cnpj_boleto = this.loadedPayment.chain.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
              } else if (this.loadedPayment.hotel && this.loadedPayment.hotel.cnpj) {
                this.payment.cnpj_boleto = this.loadedPayment.hotel.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
              } else {
                this.payment.cnpj_boleto = ''
              }
            } else {
              this.payment.cnpj_boleto = this.loadedPayment.cnpj_boleto.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
            }
          }
          if (response.body === '') {
            this.close(false)
          } else {
            document.body.appendChild(this.$el)
          }
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      showReceiptUpload () {
        this.upload_new_receipt = !this.upload_new_receipt
      },
      sendReceiptToHotel () {
        if (window.confirm('Are you sure you want to send the Receipt to the Hotel?')) {
          let API_URL = this.context.$store.state.config.apiURL
          this.context.$http.post(API_URL + '/V2/payment/send_receipt', {payment: this.context._data.selectedItens[0].id}).then((response) => {
            if (response.body === 'ok') {
              this.message('success', 'Success', 'The receipt was successfully send to the hotel')
              this.close(true)
            } else if (response.body === 'error') {
              this.message('danger', 'Erro', 'The hotel do not have a financial e-mail')
              this.close(true)
              return false
            }
          }, (response) => {
            this.message('danger', 'Error', response.body.message)
            return false
          })
        }
      },
      loadMethods () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/payment_methods', {params: { type: 1 }}).then((response) => {
          this.payment_methods = response.body
        }, (response) => {
        })
      },
      loadCards () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/finances/cardsMain').then((response) => {
          this.cards = response.body
        }, (response) => {
        })
      },
      parseCards (data) {
        let cards = []
        for (var i = 0; i < data.length; i++) {
          cards.push({name: data[i].id + ' - ' + data[i].card + ' - ' + data[i].brand + ' - ' + data[i].holder, value: data[i].id})
        }
        return cards
      },
      parsePaymentMethodSelect (methods) {
        let methodsTmp = methods.map((method) => {
          let methodName = ''
          if (parseInt(method.method_type) === 1) {
            methodName = method.card_number + ' - ' + method.card_flag + ' - CARD'
          } else {
            methodName = method.bank
            if (method.account !== null) {
              methodName = method.account + ' - ' + methodName
            }
            if (method.agency !== null) {
              methodName = method.agency + ' - ' + methodName
            }
            methodName += ' - BANK'
          }
          return {
            name: methodName,
            id: method.id
          }
        })
        return methodsTmp
      },
      handleFileUploadInvoice () {
        let ext = this.$refs.invoice.files[0].type
        if (ext !== 'application/pdf') {
          this.file = null
          this.$refs.invoice.value = ''
          this.error = 'Select a PDF file!'
        } else {
          this.file = this.$refs.invoice.files[0]
          this.error = ''
        }
      },
      handleFileUploadReceipt () {
        let ext = this.$refs.receipt.files[0].type
        if (ext !== 'application/pdf') {
          this.file2 = null
          this.$refs.receipt.value = ''
          this.error = 'Select a PDF file!'
        } else {
          this.file2 = this.$refs.receipt.files[0]
          this.error = ''
        }
      },
      close (closeOnly, pay) {
        if (closeOnly) {
          this.remove_user_id = 1
          this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/payment/set_editing_user', {payment_id: this.payment.payment_id, remove_user_id: this.remove_user_id}).then((response) => {
          }, (response) => {
            this.error = response.body
          })

          this.context[this.callback](closeOnly, pay)
        } else {
          this.context[this.callback](closeOnly, pay)
        }
        this.remove_user_id = ''
        this.$el.remove()
      },
      async submitFileInvoice () {
        if (this.file !== null) {
          let data = new window.FormData()
          data.append('file', this.file)
          data.append('payment_id', this.payment.payment_id)
          this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/payment/files/invoice', data, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
            return true
          }, (response) => {
            return true
          })
        } else {
          return true
        }
      },
      async submitFileReceipt () {
        if (this.file2 !== null) {
          let data = new window.FormData()
          data.append('file', this.file2)
          if (this.paid_status === 1) {
            data.append('payment_id', this.paid_payment)
          } else {
            data.append('payment_id', this.payment.payment_id)
          }
          this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/payment/files/receipt', data, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
            return true
          }, (response) => {
            return true
          })
        } else {
          return true
        }
      },
      async save (pay) {
        this.inProgress = true
        if (window.confirm('Are you sure you want to edit?')) {
          await this.submitFileInvoice()
          await this.submitFileReceipt()
          this.error = ''
          this.cnpjs_nf.forEach(cnpj => {
            if (!cnpj.hasOwnProperty('value')) {
              this.error = 'O CNPJ da nota fiscal é obrigatório'
            }
          })
          if (!this.error) {
            if (this.pre_payment_method === 0) {
              if (this.paid_status === 1) {
                this.payment.payment_id = [this.paid_payment]
              } else {
                this.payment.deadline = this.$refs.deadline.datepicker.input.value
              }
            }
            if (this.nf_numbers) {
              this.payment.nf_number = this.nf_numbers
              this.payment.cnpj_nf = this.cnpjs_nf
            }
            this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/payment/edit', this.payment).then((response) => {
              this.inProgress = false
              this.close(false, pay)
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          } else {
            this.inProgress = false
            setTimeout(() => {
              this.error = ''
            }, '4000')
          }
        } else {
          this.inProgress = false
        }
      },
      payCallback (result) {
        if (!result) {
          let propsData = {
            title: 'Success',
            message: 'The selected payments were successfully payed',
            type: 'success',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        }
        this.close(false, 'ok')
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    },
    components: {
      Datepicker,
      babelPolyfill,
      vSelect
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// EditPayment.vue?ee35f370